import React, { Component } from 'react';
import { translate } from 'react-polyglot';
import PropTypes from 'prop-types';

import Modal from '../Modal';
import Button from '../Button';
import ButtonGroup from '../ButtonGroup';

import './ConfirmModal.scss';

class ConfirmModal extends Component {  
  render() {
    const {
      t,
      title,
      heading,
      viewport,
      onClose,
      onConfirm,
      customRightButton,
      customLeftButton,
      onModalClose
    } = this.props;
    const baseClassName = 'pb-confirm-modal';

    const headerEl = !heading && (
      <h2>{title || t('global.confirm')}</h2>
    );

    const footerEl = (
      <ButtonGroup mergeTop mergeBottom={!viewport.large} mergeSides>
        <Button
          variant="primary"
          fullWidth
          label={customLeftButton || t('global.yes')}
          onClick={() => onConfirm()}
        />
        <Button fullWidth label={customRightButton || t('global.close')} onClick={onClose} />
      </ButtonGroup>
    );
    
    return (
      <Modal
        header={headerEl}
        footer={footerEl}
        onClose={onModalClose || onClose}
        isRtl={this.props.isRtl}
      >
        {heading && <div className={`${baseClassName}__heading`}>{heading}</div>}
        {this.props.text}
      </Modal>
    );
  }
}

ConfirmModal.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  viewport: PropTypes.object.isRequired
};

export default translate()(ConfirmModal);



// WEBPACK FOOTER //
// ./src/components/ConfirmModal/ConfirmModal.jsx